
        import {createContext, useState} from 'react';
        export const ZibiContext = createContext(null);
        export const ZibiContextProvider = ({children}) => {
         
        let [user, set_user] = useState(null);
        
        let [shopper, set_shopper] = useState(null);
        
        let [isLoggedIn, set_isLoggedIn] = useState(false);
        
        let [busyIndicator, set_busyIndicator] = useState(0);
        
        let [language, set_language] = useState('EN');
        
        let [languageMap, set_languageMap] = useState({});
        
        let [languageOptions, set_languageOptions] = useState([]);
        
        let [initialRoutePath, set_initialRoutePath] = useState(null);
        
        let [currentSite, set_currentSite] = useState(null);
        
        let [chooseSiteRequired, set_chooseSiteRequired] = useState(false);
        
        let [checkInRequired, set_checkInRequired] = useState(true);
        
        let [sitesList, set_sitesList] = useState([]);
        
        let [productsById, set_productsById] = useState({});
        
        let [productsByBarCode, set_productsByBarCode] = useState({});
        
        let [productsCart, set_productsCart] = useState([]);
        
        let [stats_mode, set_stats_mode] = useState(false);
        
        let [stats, set_stats] = useState({});
        
        let [cartViewTable, set_cartViewTable] = useState(false);
        
        let [sensorStatuses, set_sensorStatuses] = useState({});
        
        let [shopperProductsCart, set_shopperProductsCart] = useState({});
        
        let [cameras, set_cameras] = useState({});
        
        let [categories, set_categories] = useState([]);
        
        let [camerasOnVif, set_camerasOnVif] = useState([]);
        
        let [fields, set_fields] = useState({});
        
        let [sensors, set_sensors] = useState({});
        
        let [clients, set_clients] = useState([]);
        
        let [sitesByClientId, set_sitesByClientId] = useState({});
        
        let [siteEdges, set_siteEdges] = useState([]);
        
        let [siteFields, set_siteFields] = useState([]);
        
        let [siteCameras, set_siteCameras] = useState({});
        window.zibi = {};
window.zibi.user = user;
window.zibi.set_user = val => {
            set_user(val);
            user = val;
             window.zibi.user = user;
        };
window.zibi.shopper = shopper;
window.zibi.set_shopper = val => {
            set_shopper(val);
            shopper = val;
             window.zibi.shopper = shopper;
        };
window.zibi.isLoggedIn = isLoggedIn;
window.zibi.set_isLoggedIn = val => {
            set_isLoggedIn(val);
            isLoggedIn = val;
             window.zibi.isLoggedIn = isLoggedIn;
        };
window.zibi.busyIndicator = busyIndicator;
window.zibi.set_busyIndicator = val => {
            set_busyIndicator(val);
            busyIndicator = val;
             window.zibi.busyIndicator = busyIndicator;
        };
window.zibi.language = language;
window.zibi.set_language = val => {
            set_language(val);
            language = val;
             window.zibi.language = language;
        };
window.zibi.languageMap = languageMap;
window.zibi.set_languageMap = val => {
            set_languageMap(val);
            languageMap = val;
             window.zibi.languageMap = languageMap;
        };
window.zibi.languageOptions = languageOptions;
window.zibi.set_languageOptions = val => {
            set_languageOptions(val);
            languageOptions = val;
             window.zibi.languageOptions = languageOptions;
        };
window.zibi.initialRoutePath = initialRoutePath;
window.zibi.set_initialRoutePath = val => {
            set_initialRoutePath(val);
            initialRoutePath = val;
             window.zibi.initialRoutePath = initialRoutePath;
        };
window.zibi.currentSite = currentSite;
window.zibi.set_currentSite = val => {
            set_currentSite(val);
            currentSite = val;
             window.zibi.currentSite = currentSite;
        };
window.zibi.chooseSiteRequired = chooseSiteRequired;
window.zibi.set_chooseSiteRequired = val => {
            set_chooseSiteRequired(val);
            chooseSiteRequired = val;
             window.zibi.chooseSiteRequired = chooseSiteRequired;
        };
window.zibi.checkInRequired = checkInRequired;
window.zibi.set_checkInRequired = val => {
            set_checkInRequired(val);
            checkInRequired = val;
             window.zibi.checkInRequired = checkInRequired;
        };
window.zibi.sitesList = sitesList;
window.zibi.set_sitesList = val => {
            set_sitesList(val);
            sitesList = val;
             window.zibi.sitesList = sitesList;
        };
window.zibi.productsById = productsById;
window.zibi.set_productsById = val => {
            set_productsById(val);
            productsById = val;
             window.zibi.productsById = productsById;
        };
window.zibi.productsByBarCode = productsByBarCode;
window.zibi.set_productsByBarCode = val => {
            set_productsByBarCode(val);
            productsByBarCode = val;
             window.zibi.productsByBarCode = productsByBarCode;
        };
window.zibi.productsCart = productsCart;
window.zibi.set_productsCart = val => {
            set_productsCart(val);
            productsCart = val;
             window.zibi.productsCart = productsCart;
        };
window.zibi.stats_mode = stats_mode;
window.zibi.set_stats_mode = val => {
            set_stats_mode(val);
            stats_mode = val;
             window.zibi.stats_mode = stats_mode;
        };
window.zibi.stats = stats;
window.zibi.set_stats = val => {
            set_stats(val);
            stats = val;
             window.zibi.stats = stats;
        };
window.zibi.cartViewTable = cartViewTable;
window.zibi.set_cartViewTable = val => {
            set_cartViewTable(val);
            cartViewTable = val;
             window.zibi.cartViewTable = cartViewTable;
        };
window.zibi.sensorStatuses = sensorStatuses;
window.zibi.set_sensorStatuses = val => {
            set_sensorStatuses(val);
            sensorStatuses = val;
             window.zibi.sensorStatuses = sensorStatuses;
        };
window.zibi.shopperProductsCart = shopperProductsCart;
window.zibi.set_shopperProductsCart = val => {
            set_shopperProductsCart(val);
            shopperProductsCart = val;
             window.zibi.shopperProductsCart = shopperProductsCart;
        };
window.zibi.cameras = cameras;
window.zibi.set_cameras = val => {
            set_cameras(val);
            cameras = val;
             window.zibi.cameras = cameras;
        };
window.zibi.categories = categories;
window.zibi.set_categories = val => {
            set_categories(val);
            categories = val;
             window.zibi.categories = categories;
        };
window.zibi.camerasOnVif = camerasOnVif;
window.zibi.set_camerasOnVif = val => {
            set_camerasOnVif(val);
            camerasOnVif = val;
             window.zibi.camerasOnVif = camerasOnVif;
        };
window.zibi.fields = fields;
window.zibi.set_fields = val => {
            set_fields(val);
            fields = val;
             window.zibi.fields = fields;
        };
window.zibi.sensors = sensors;
window.zibi.set_sensors = val => {
            set_sensors(val);
            sensors = val;
             window.zibi.sensors = sensors;
        };
window.zibi.clients = clients;
window.zibi.set_clients = val => {
            set_clients(val);
            clients = val;
             window.zibi.clients = clients;
        };
window.zibi.sitesByClientId = sitesByClientId;
window.zibi.set_sitesByClientId = val => {
            set_sitesByClientId(val);
            sitesByClientId = val;
             window.zibi.sitesByClientId = sitesByClientId;
        };
window.zibi.siteEdges = siteEdges;
window.zibi.set_siteEdges = val => {
            set_siteEdges(val);
            siteEdges = val;
             window.zibi.siteEdges = siteEdges;
        };
window.zibi.siteFields = siteFields;
window.zibi.set_siteFields = val => {
            set_siteFields(val);
            siteFields = val;
             window.zibi.siteFields = siteFields;
        };
window.zibi.siteCameras = siteCameras;
window.zibi.set_siteCameras = val => {
            set_siteCameras(val);
            siteCameras = val;
             window.zibi.siteCameras = siteCameras;
        };

    return (
        <ZibiContext.Provider value={{
          
        user_context: [user, set_user],
        
        shopper_context: [shopper, set_shopper],
        
        isLoggedIn_context: [isLoggedIn, set_isLoggedIn],
        
        busyIndicator_context: [busyIndicator, set_busyIndicator],
        
        language_context: [language, set_language],
        
        languageMap_context: [languageMap, set_languageMap],
        
        languageOptions_context: [languageOptions, set_languageOptions],
        
        initialRoutePath_context: [initialRoutePath, set_initialRoutePath],
        
        currentSite_context: [currentSite, set_currentSite],
        
        chooseSiteRequired_context: [chooseSiteRequired, set_chooseSiteRequired],
        
        checkInRequired_context: [checkInRequired, set_checkInRequired],
        
        sitesList_context: [sitesList, set_sitesList],
        
        productsById_context: [productsById, set_productsById],
        
        productsByBarCode_context: [productsByBarCode, set_productsByBarCode],
        
        productsCart_context: [productsCart, set_productsCart],
        
        stats_mode_context: [stats_mode, set_stats_mode],
        
        stats_context: [stats, set_stats],
        
        cartViewTable_context: [cartViewTable, set_cartViewTable],
        
        sensorStatuses_context: [sensorStatuses, set_sensorStatuses],
        
        shopperProductsCart_context: [shopperProductsCart, set_shopperProductsCart],
        
        cameras_context: [cameras, set_cameras],
        
        categories_context: [categories, set_categories],
        
        camerasOnVif_context: [camerasOnVif, set_camerasOnVif],
        
        fields_context: [fields, set_fields],
        
        sensors_context: [sensors, set_sensors],
        
        clients_context: [clients, set_clients],
        
        sitesByClientId_context: [sitesByClientId, set_sitesByClientId],
        
        siteEdges_context: [siteEdges, set_siteEdges],
        
        siteFields_context: [siteFields, set_siteFields],
        
        siteCameras_context: [siteCameras, set_siteCameras],
        
        }}>
            {children}
        </ZibiContext.Provider>
    );
};
        